import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/municipalities/all/{district_code}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetAllGeoMunicipalitiesOfDistrictInput = paths[url]['get']['parameters']['path'];
export interface GetAllGeoMunicipalitiesOfDistrictSuccessResponse {
    data: paths[url]['get']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to get all available municipalities for one district.
 */
export const useGetAllGeoMunicipalitiesOfDistrict = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setAllGeoMunicipalitiesOfDistrict } = useData();
    const [loading, setLoading] = useState<boolean>(false);

    const request = async (props: GetAllGeoMunicipalitiesOfDistrictInput) => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{district_code}', props.district_code || '')}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetAllGeoMunicipalitiesOfDistrictSuccessResponse = await response.json();

            setAllGeoMunicipalitiesOfDistrict(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, loading };
};
